module.exports = __webpack_public_path__ + "static/media/glowing-container-mobile.5718e6a6.png";